import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import CustomMenu from "../../../components/UI/Menus/CustomMenu/CustomMenu";
import CustomTabs from "../../../components/UI/Tabs/CustomTabs/CustomTabs";
import { MenuItemEntity } from "../../../entities/UIEntities/MenuItem";
import { TabItemEntity } from "../../../entities/UIEntities/TabItem";
import { CAMPAIGN_TYPES, MENU_ITEMS } from "../../../enums/Enums";
import useMessagingService from "../../../hooks/useMessagingService";
import Icons from "../../../resources/icons/Icons";
import Strings from "../../../resources/Strings";
import {
  deleteList,
  handleEditCampaign,
  handleDeleteCampaign,
  handleEditMailingList,
  handleDuplicateCampaign,
} from "../../../utils/MenuUtils";
import classes from "./ParkerInfo.module.css";
import PageHeader from "../../../components/UI/Headers/PageHeader/PageHeader";

const MessagingInfo = (props) => {
  const { getMessagingDetails } = useMessagingService();
  const isOpenedFromMessagingHistory = props?.tableName === Strings.TABS_NAMES.MESSAGING_HISTORY;
  let tabs = [];
  
  const getTabInfoData = () => {
    // returns both icon and menuItems according to the selected tab
    let icon = "";
    let menuItems = []; 
    switch (props?.tableName) {
      case Strings.TABS_NAMES.CAMPAIGNS:
        icon = props?.campaignType === CAMPAIGN_TYPES.MOBILE ? Icons.PHONE : Icons.EMAIL;
        menuItems = [
          new MenuItemEntity(
            MENU_ITEMS.EDIT_CAMPAIGN,
            handleEditCampaign,
            true,
            Icons.EDIT_ITEM,
            false,
            props
          ),
          new MenuItemEntity(
            MENU_ITEMS.DUPLICATE_CAMPAIGN,
            handleDuplicateCampaign,
            true,
            Icons.EDIT_ITEM,
            false,
            props
          ),
          new MenuItemEntity(
            MENU_ITEMS.DELETE_CAMPAIGN,
            handleDeleteCampaign,
            true,
            Icons.DELETE_ITEM,
            false,
            props
          )
        ].filter(item => item);
        break;

      case Strings.TABS_NAMES.MESSAGING_HISTORY:
        icon = props?.campaignType === CAMPAIGN_TYPES.MOBILE ? Icons.PHONE : Icons.EMAIL;
        break;

      case Strings.TABS_NAMES.MAILING_LISTS:
        icon = Icons.MAILING_LIST;
        menuItems = [
          new MenuItemEntity(
            MENU_ITEMS.EDIT_LIST,
            handleEditMailingList,
            true,
            Icons.EDIT_ITEM,
            false,
            props
          ),
          new MenuItemEntity(
            MENU_ITEMS.DELETE_LIST,
            deleteList, 
            true,
            Icons.DELETE_ITEM,
            false,
            props 
          )
        ];
        break;
      default:
    }

    return {menuItems, icon}; 
  };

  const detailsTab = new TabItemEntity(
    Strings.TABS_NAMES.DEATILS,
    Strings.TABS_NAMES.DEATILS,
    getMessagingDetails(props) // (props)
  );

//   const activityTab = new TabItemEntity(
//     Strings.TABS_NAMES.ACTIVITY,
//     Strings.TABS_NAMES.ACTIVITY,
//     getGmtActivity(props)
//   );

  tabs.push(detailsTab);
  //tabs.push(activityTab);

  const onTabChange = () => {};

  const handleClose = () => {
    props.handleCloseEvent();
  };

  return (
    <div className={classes.parkerInfo}>
      <IconButton
        className={classes.closeButton}
        aria-label="closeIcon"
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.messagingInfoHeader}>
        {/* <PageAvatarInfo
          name={props?.name}
          image={props?.type === CAMPAIGN_TYPES.MOBILE ? Icons.PHONE : Icons.EMAIL} // props?.utronUser?.image 
          sizeClass="big"
          hasAppBadge={props.app}
        ></PageAvatarInfo> */}
        <PageHeader 
          icon={getTabInfoData()?.icon}
          pageTitle={props?.name || props?.campaign?.name}
          //subTitle={props?.token?.value}
          //buttonText={Strings.ADD_NEW_PARKER}
        />
        {props.validRole && getTabInfoData()?.menuItems?.length > 0 && <CustomMenu menuItems={getTabInfoData()?.menuItems}></CustomMenu>}
      </div>
      <CustomTabs
        initialTab={Strings.TABS_NAMES.DEATILS}
        tableName={props?.tableName}
        onTabChange={onTabChange}
        isHidden={true}
        isOverflowNeeded={true}
        panelSx={isOpenedFromMessagingHistory ? {marginTop: '-70px'} : {marginTop: '-51px'}}
        tabs={tabs}
      ></CustomTabs>
    </div>
  );
};

export default MessagingInfo;
